import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Text } from '@mantine/core';
import type { DeadlineUrgency, UpcomingDeadline } from '@/lib/dashboard';
import { ROUTES } from '@/routes/paths';
import classes from './home.module.css';

// Один форматтер на модуль (Intl-конструктор дорогой). «ДД.ММ».
const dayMonth = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit' });

// Срочность словом и цветом: сегодня — красным, завтра — основным цветом текста, дальше — вторичным.
const URGENCY_COLOR: Readonly<Record<DeadlineUrgency, string>> = {
  today: 'loss.7',
  tomorrow: 'var(--mantine-color-text)',
  date: 'gray.7',
};

interface UpcomingDeadlinesProps {
  readonly items: readonly UpcomingDeadline[];
}

// Ближайшие плановые сроки по сделкам — заранее предупредить о подходящей отгрузке. Строки как в ленте дел.
export default function UpcomingDeadlines({ items }: UpcomingDeadlinesProps) {
  const { t } = useTranslation();

  return (
    <div>
      {items.map((item) => {
        const when =
          item.urgency === 'today'
            ? t('app.home.deadlines.today')
            : item.urgency === 'tomorrow'
              ? t('app.home.deadlines.tomorrow')
              : dayMonth.format(new Date(item.dateMs));
        return (
          <Link key={item.dealId} to={`${ROUTES.APP_DEALS}/${item.dealId}`} className={`${classes.row} ${classes.item}`}>
            <Text fw={500}>
              {[item.goods, t('app.home.dealShort', { no: item.dealNo })].filter(Boolean).join(' · ')}
            </Text>
            <Text fw={600} c={URGENCY_COLOR[item.urgency]} className={classes.itemRight}>
              {when}
            </Text>
          </Link>
        );
      })}
    </div>
  );
}
